import PropTypes from "prop-types";

const MetadataField = ({ icon: Icon, label, value, isMultiline = false }) => {
  if (!value) return null;

  if (isMultiline) {
    return (
      <div className="py-2 sm:py-3">
        <div className="flex items-center gap-2 mb-1">
          {Icon && <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#515164" }} />}
          <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
            {label}
          </span>
        </div>
        <div className="pl-5 sm:pl-6">
          <span className="text-xs sm:text-sm font-normal" style={{ color: "#515164" }}>
            {value}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-center py-2 sm:py-2.5 gap-2 sm:gap-3">
      <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
        {Icon && (
          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#515164" }} />
        )}
        <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
          {label}
        </span>
      </div>
      <span
        className="text-xs sm:text-sm font-normal text-right shrink-0"
        style={{ color: "#515164" }}
      >
        {value}
      </span>
    </div>
  );
};

MetadataField.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMultiline: PropTypes.bool,
};

export default MetadataField;
